import trim from 'lodash/trim';

export const splitDomains = (domains) => (domains || '').split(/[\n ]/).map(trim).filter(Boolean);
